module.exports = __webpack_public_path__ + "static/media/br.aa1e61da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/br.svg
// module id = 72
// module chunks = 0